const agentStatus = [
    {
        id: 1,
        heading: 'No Sales',
        value: '20'
    },
    {
        id: 2,
        heading: 'Sales',
        value: '40'
    },
    {
        id: 3,
        heading: 'Emotions',
        value: '80'
    }
];

export default agentStatus;